export const supportLink = 'https://customerportal.solarwinds.com/support/submit-a-ticket?sw-saas-support';
export const errorCookieName = 'errorCookie';
